/**
 * @file TasksFoot.jsx
 * @location src/components/tasks/TasksFoot.jsx
 * @role 업무탭 우하단 — 완료 이력(이력) 진입 + 안내. 매니저·팀원 페이지 공용.
 *   당일 지난 완료 업무는 이력(완료이력 모달)로 보관된다.
 */
import { useApp } from '../../store/AppContext';
import { Icon } from '../ui/Icon';

export function TasksFoot() {
  const { act } = useApp();
  return (
    <div className="tasks-foot">
      <span className="tasks-foot-note">당일이 지난 완료 업무는 여기에 보관됩니다</span>
      <button className="btns" onClick={() => act('SET_UI', { patch: { modalHistory: true } })}>
        <Icon name="document" size={14} /> 이력
      </button>
    </div>
  );
}
